<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <h1>
      Parking Place Info
      <!-- <small>Preview</small> -->
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="/user/home"> <i class="fa fa-dashboard"></i> Home</a>
      </li>
      <li class="active">Parking Place Info</li>
    </ol>
  </section>
  <!-- Main content -->
  <section class="content">
    <div class="row">
      <div class="col-md-3">
        <!-- Profile Image -->
        <div class="box box-solid box-primary">
          <div class="box-header with-border">
            <h3 class="profile-username text-center">{{ form?.title }}</h3>
            <div class="box-tools pull-right">
              <!-- Collapse Button -->
              <button type="button" class="btn btn-box-tool" data-widget="collapse">
                <i class="fa fa-minus"></i>
              </button>
            </div>
            <!-- /.box-tools -->
          </div>
          <div class="box-body box-profile">
            <ul class="list-group list-group-unbordered">
              <li class="list-group-item">
                <b>ID</b>
                <a class="pull-right">{{ id }}</a>
              </li>
              @if (data?.parking_place?.uid) {
              <li class="list-group-item">
                <b>UID</b>
                <a class="pull-right">{{ data?.parking_place?.uid }}</a>
              </li>
              }
              <li class="list-group-item">
                <b>Capacity</b>
                <a class="pull-right">{{ form?.occupancy }}/{{ form?.capacity }}</a>
              </li>
              @if (data?.parking_place?.parking_place_type.title) {
              <li class="list-group-item">
                <b>Parking Type</b>
                <a class="pull-right">{{ data?.parking_place?.parking_place_type.title }}</a>
              </li>
              }
              @if (data?.subscription?.id) {
              <li class="list-group-item">
                <b>Subscription</b>
                <a class="pull-right">{{ data?.subscription?.allocated }}/{{
                  data?.subscription?.limit
                  }}</a>
              </li>
              }
              @if (data?.subscription?.id) {
              <li class="list-group-item">
                <b>Subscription</b>
                <form [formGroup]="subscriptionForm" style="display: inline-block; float: right;">
                  {{ data?.subscription?.allocated }}/<input #total (blur)="resetSubscriptionLimit()"
                    (keyup.enter)="updateSubscriptionLimit(total.value)" class="form-control" id="input-sm"
                    formControlName="limit" type="number" />
                </form>
              </li>
              }
              <li class="list-group-item">
                <b>Area</b>
                <a class="pull-right">
                  <span>{{ form?.area }}</span>
                </a>
              </li>
              @if (form?.city) {
              <li class="list-group-item">
                <b>City</b>
                <a class="pull-right">{{ form?.city }}</a>
              </li>
              }
              <li class="list-group-item">
                <b>Country</b>
                <a class="pull-right">{{ form?.country }}</a>
              </li>
            </ul>
          </div>
          <!-- /.box-body -->
        </div>

        <!-- /.box -->
      </div>
      <!-- /.col -->
      <div class="col-md-9">
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs">
            <li>
              <a href="#settings-tab" data-toggle="tab" (click)="refreshMap()">Settings</a>
            </li>
            <li>
              <a href="#staffs-tab" data-toggle="tab">Staffs</a>
            </li>
          </ul>
          <div class="tab-content">
            <!-- /.tab-pane -->
            <div class="tab-pane" id="liveparking-tab">
              <parking-place-live-parking [group]="groupName" [id]="id"></parking-place-live-parking>
              <!-- /.box -->
            </div>
            <!-- /.tab-pane -->
            <div class="tab-pane" id="parkinghistory-tab">
              <!-- general form elements -->
              <parking-place-parking-history [group]="groupName" [id]="id"></parking-place-parking-history>
            </div>
            <!-- /.tab-pane -->
            <div class="active tab-pane" id="settings-tab">
              <!-- general form elements -->
              <app-add-vallet-parking (submit)="updateValetParking($event)" [logo]="data.logo" [data]="form">
              </app-add-vallet-parking>
              <!-- /.box -->
            </div>
            <!-- /.tab-pane -->
            <div class="tab-pane" id="staffs-tab">
              <!-- general form elements -->
              <app-vallet-parking-staffs [group]="groupName" [id]="id"></app-vallet-parking-staffs>
              <!-- /.box -->
            </div>
            <!-- /.tab-pane -->
            <div class="tab-pane" id="revenue-tab">
              <!-- Map box -->
              <div class="box box-solid">
                <div class="box-body">
                  @if (revenueChart) {
                  <ngx-charts-bar-vertical-stacked [scheme]="sharedSettings.colorScheme" [customColors]="[
                        {
                          name: 'pass',
                          value: passColor
                        }
                      ]" [results]="revenueChart" [roundDomains]="sharedSettings.roundDomains"
                    [legendTitle]="'Benficiaries'" [gradient]="sharedSettings.gradient"
                    [xAxis]="sharedSettings.showXAxis" [yAxis]="sharedSettings.showYAxis" [legend]="true"
                    [showXAxisLabel]="sharedSettings.showXAxisLabel" [showYAxisLabel]="sharedSettings.showYAxisLabel"
                    [xAxisLabel]="'Parking places'" [yAxisLabel]="'Revenue'"></ngx-charts-bar-vertical-stacked>
                  }
                </div>
                <!-- /.box-body-->
              </div>
              <!-- /.box -->
            </div>

            <div class="tab-pane" id="pos-machines-tab">
              <!-- general form elements -->
              <app-pos-machines [group]="groupName" [id]="id"></app-pos-machines>
              <!-- /.box -->
            </div>
            <!-- /.tab-pane -->
          </div>
          <!-- /.tab-content -->
        </div>
        <!-- /.nav-tabs-custom -->
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</div>
<!-- /.content-wrapper -->